export const INNER_CLASSES = 'inner max-width-container';
export const TAG_PAGE_SOURCE = 'tag_page';
export const TEASER_CONTENT = [
    {
        id: 1,
        class: 'add-logo',
    },
    {
        id: 2,
        class: 'create-variations',
    },
    {
        id: 3,
        class: 'ai-working',
    },
];
